import { Disclosure } from "@headlessui/react";
import ChevronRight from "@material-ui/icons/ChevronRight";
import type { DigitalAsset } from "../types";

interface MetaSectionProps {
  asset: DigitalAsset;
}

const MetaSection = ({ asset }: MetaSectionProps) => (
  <Disclosure defaultOpen>
    {({ open }) => (
      <div className="bg-white rounded-lg box-shadow">
        <Disclosure.Button className="disclosureBtn ml-2">
          <ChevronRight
            className={`${
              open ? "transform rotate-90" : " text-gray-500"
            } text-gray-500 w-5 h-5 `}
          />
          <span className="disclosureLabel ml-2">Meta Information</span>
        </Disclosure.Button>

        <Disclosure.Panel className="text-xs">
          <div className="grid grid-cols-2 text-xs">
            <div className="grid grid-cols-1 py-2 px-4 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Title Tag:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {asset.title_Tag__C && asset.title_Tag__C !== "NULL"
                  ? asset.title_Tag__C
                  : ""}
              </div>
              <div className="border-b border-gray-200"></div>
            </div>

            <div className="grid grid-cols-1 py-2 px-4 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Title Tag SPA:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {asset.title_Tag_Spa__C && asset.title_Tag_Spa__C !== "NULL"
                  ? asset.title_Tag_Spa__C
                  : ""}
              </div>
              <div className="border-b border-gray-200"></div>
            </div>

            <div className="grid grid-cols-1 py-2 px-4 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Meta Description:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {asset.meta_Description__C &&
                asset.meta_Description__C !== "NULL"
                  ? asset.meta_Description__C
                  : ""}
              </div>
            </div>

            <div className="grid grid-cols-1 py-2 px-4 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Meta Description SPA:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {asset.meta_Description_Spa__C &&
                asset.meta_Description_Spa__C !== "NULL"
                  ? asset.meta_Description_Spa__C
                  : ""}
              </div>
            </div>
          </div>
        </Disclosure.Panel>
      </div>
    )}
  </Disclosure>
);

export default MetaSection;